export default "__VITE_ASSET__D21ur0d___"